import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

var _templateObject, _templateObject2;
var CarouselDot = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-1alziwb-0"
})(["all:unset;cursor:pointer;:focus{outline:1px solid ", ";}display:inline-block;width:8px;height:8px;background-color:", ";border-radius:50%;vertical-align:middle;transition:all 150ms linear 0s;margin:0 2px;&:first-child{margin-left:0;}&:last-child{margin-right:0;}&.pagination-dot-enter{transition:all 30ms linear;display:inline-block;opacity:0;}", " ", ""], token('colors.brand'), token('colors.gray300'), function (props) {
  return props.isActive ? css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n                  background-color: ", ";\n              "])), token('colors.brand')) : '';
}, function (props) {
  return props.isContinuation ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n                  height: 4px;\n                  width: 4px;\n              "]))) : '';
});
CarouselDot.propTypes = {
  isActive: PropTypes.boolean,
  isContinuation: PropTypes.boolean
};
var CarouselDot$1 = CarouselDot;

export { CarouselDot$1 as default };
